export default __webpack_public_path__ + "static/assets/3887f52c07535845604169600074a4ee.svg";